<section class="border-border background-hover-info">
  <div class="party-info" [class.party-info--togo]="party().type === partyTypes.togo">
    <div class="main-info" [class.main-info--togo]="party().type === partyTypes.togo">
      @if (party().type !== partyTypes.togo) {
        <div class="guests">
          <tr-icon [icon]="icon.customers"></tr-icon>
          <p class="guests ml-2">{{ party().size }} guests</p>

          <div class="chip space ml-3" [style.background]="cardTypeColorMap[partyType()].background">
            <span [style.color]="cardTypeColorMap[partyType()].text">{{ partyType() }}</span>
          </div>
        </div>
      }

      <button class="btn btn-info" (click)="partyNavigationService.navigateToPartyPage(party())">View</button>
    </div>

    @if (party()) {
      <tablesready-table-time
        [type]="partyType()"
        [iconColor]="iconColor"
        [checkInTime]="party().checkin_time"
        [seatedTime]="party().seated_time"
        [quotedTime]="party().quoted_time"
        [duration]="party().duration"
        [canceledTime]="party().canceled_time ?? 0"
        [timezone]="timezone()"
        [isReservation]="party().type === partyTypes.reservation"
        colorClass=""
      ></tablesready-table-time>
    }
  </div>
</section>
